import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserStore, FilterStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { PVAContentHeader, PVAContentBody } from '../components';
import './Home.css';

interface HomeProps extends RouteComponentProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class Home extends React.Component<HomeProps> {
    @computed get logoUrl() {
        if (this.props.FilterStore!.organization && this.props.FilterStore!.organization.logo) {
            return this.props.FilterStore!.organization.logo;
        } else {
            return null;
        }
    }

    @computed get organization() {
        return this.props.FilterStore!.organization;
    }

    @computed get firstName() {
        return `${this.props.UserStore!.userInfo.firstName}`;
    }

    private logo() {
        if (!this.logoUrl) {
            if (this.organization) {
                return (
                    <div className="pva-home-org-name-component">
                        <h3>{this.organization.name}</h3>
                    </div>);
            }
            return <div />;
        }

        const logoImg = (
            <div className={`logo-container ${this.organization && this.organization.logoStyle}`}>
                <img src={this.logoUrl} />
            </div>);

        return (
            <div className="pva-home-org-logo-component">
                {logoImg}
            </div>
        );
    }

    public render() {

        let logoComponent = this.logo();

        return (
            <div>
                <PVAContentHeader>
                    <h3>Welcome, {this.firstName}</h3>
                </PVAContentHeader>

                <PVAContentBody>
                    <div className="pva-welcome pva-welcome-no-padding">
                        {logoComponent}
                        <div>
                            <img className="hidden-xs" src={`images/pvaStyleGraphic_0_Neutral.svg`} />
                        </div>
                    </div>
                </PVAContentBody>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.tsx